/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { FormControl } from '@material-ui/core';
import Datetime from 'react-datetime';
import moment, { Moment } from 'moment';
import { FilterReducerFieldName, FilterReducers } from '../filter/FilterReducers';
import { connect } from 'react-redux';
import GridContainer from '../../components/Grid/GridContainer';
import SearchNull from '../../components/Adescom/SearchNull';
import Grid from '@material-ui/core/Grid';

interface EsDateTimeFromToProps {
    dispatch: any;
    classes: any;
    defaultValue?: string;
    fieldName: string;
    dateFormat: string | null;
    beforeSetToMax?: boolean | null;
    afterSetToMin?: boolean | null;
    timeFormat?: boolean | string;
    breakLine?: boolean;

    callback(fieldName: string, value: string | null): void;

    searchActionCallback(): void;

    clearField?: boolean;
    nullable?: boolean;
    autoComplete?: string;
}

interface EsDateTimeFromToState {
    hasValue: boolean;
    valueAfter?: string | number | readonly string[];
    valueBefore?: string | number | readonly string[];
}

class EsDateTimeFromTo extends PureComponent<EsDateTimeFromToProps, EsDateTimeFromToState> {
    constructor(props: EsDateTimeFromToProps, context: EsDateTimeFromToState) {
        super(props, context);
        this.state = {
            hasValue: false,
            valueAfter: '',
            valueBefore: '',
        };
    }

    componentDidUpdate(prevProps: Readonly<EsDateTimeFromToProps>, prevState: Readonly<EsDateTimeFromToState>, snapshot?: any): void {
        const { clearField, dispatch } = this.props;
        const { hasValue } = this.state;
        if (hasValue && clearField) {
            this.clearInput();
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    dateTimeCallback = (moment: Moment | string, fieldNameInput: string): void => {
        const { callback, beforeSetToMax, afterSetToMin, fieldName, dispatch } = this.props;

        if (typeof moment === 'string') {
            if (moment === 'null') {
                this.setState({ valueBefore: 'null', valueAfter: 'null', hasValue: true }, () => {
                    callback(fieldName, moment);
                    dispatch({
                        type: 'headerFilterManage',
                        headerFilterElementName: fieldName + '[after]',
                        headerFilterElementHasValue: true,
                    });
                    dispatch({
                        type: 'headerFilterManage',
                        headerFilterElementName: fieldName + '[before]',
                        headerFilterElementHasValue: true,
                    });
                });
            } else {
                if (fieldNameInput === fieldName + '[before]') {
                    this.setState({ valueBefore: moment, hasValue: true }, () => {
                        callback(fieldName, moment);
                    });
                    callback(fieldName + '[before]', '');
                }
                if (fieldNameInput === fieldName + '[after]') {
                    this.setState({ valueAfter: moment, hasValue: true }, () => {
                        callback(fieldName, moment);
                    });
                    callback(fieldName + '[after]', '');
                }
            }
        } else {
            let format = this.getFormat(false);
            if (beforeSetToMax && fieldNameInput === fieldName + '[before]') {
                format = 'YYYY-MM-DD 23:59:59';
                const dateTimeString = moment.format(format);
                this.setState({ valueBefore: moment.format(this.getFormat(false)), hasValue: true }, () => {
                    callback(fieldNameInput, dateTimeString);
                });
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName + '[before]',
                    headerFilterElementHasValue: true,
                });
            }
            if (afterSetToMin && fieldNameInput === fieldName + '[after]') {
                format = 'YYYY-MM-DD 00:00:00';
                const dateTimeString = moment.format(format);
                this.setState({ valueAfter: moment.format(this.getFormat(false)), hasValue: true }, () => {
                    callback(fieldNameInput, dateTimeString);
                });
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName + '[after]',
                    headerFilterElementHasValue: true,
                });
            }
            if (!beforeSetToMax && fieldNameInput === fieldName + '[before]') {
                format = this.getFormat(false);
                const dateTimeString = moment.format(format);
                this.setState({ valueBefore: moment.format(this.getFormat(false)), hasValue: true }, () => {
                    callback(fieldNameInput, dateTimeString);
                });
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName + '[before]',
                    headerFilterElementHasValue: true,
                });
            }
            if (!afterSetToMin && fieldNameInput === fieldName + '[after]') {
                format = this.getFormat(false);
                const dateTimeString = moment.format(format);
                this.setState({ valueAfter: moment.format(this.getFormat(false)), hasValue: true }, () => {
                    callback(fieldNameInput, dateTimeString);
                });
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName + '[after]',
                    headerFilterElementHasValue: true,
                });
            }
        }
    };

    getFormat = (org: boolean): string => {
        const { dateFormat } = this.props;
        let dateF = 'YYYY-MM-DD HH:mm';
        if (dateFormat) {
            let tmpDateFormat = dateFormat;
            //DateFormat syntax fix
            const timeIndex = dateFormat.indexOf('HH:MM');
            if (timeIndex > -1 && !org) {
                tmpDateFormat = dateFormat.substring(0, timeIndex) + 'HH:mm' + dateFormat.substring(timeIndex + 5);
            }
            //!DateFormat syntax fix

            if (org) {
                dateF = tmpDateFormat;
            } else {
                dateF = tmpDateFormat.replace(/RRRR/gi, 'YYYY');
            }
        }
        return dateF;
    };

    clearInput = (): void => {
        this.setState({
            hasValue: false,
            valueBefore: '',
            valueAfter: '',
        });
    };

    actionChange = (e: any): void => {
        const { searchActionCallback } = this.props;
        if (e.key === 'Enter' && searchActionCallback) {
            searchActionCallback();
        }
    };

    render(): React.ReactNode {
        const { classes, defaultValue, fieldName, breakLine, timeFormat, nullable, autoComplete } = this.props;
        const { valueAfter, valueBefore } = this.state;

        const styleAppendix: { opacity?: string; color?: string; unselectable?: string } = {};
        if (valueAfter === 'null') {
            styleAppendix.color = 'rgba(0,0,0,0)';
        }
        const dateF = this.getFormat(true);
        const nowStart: Moment = moment();
        const nowEnd: Moment = moment();
        nowStart.set({
            hours: 0,
            minutes: 0,
            seconds: 0,
        });
        nowEnd.set({
            hours: 23,
            minutes: 59,
            seconds: 59,
        });

        return (
            <GridContainer style={{ marginRight: nullable ? '40px' : '0' }}>
                {nullable && (
                    <Grid item xs={3}>
                        <SearchNull fieldType={'date'} fieldName={fieldName} value={valueAfter} updateCallback={this.dateTimeCallback} />
                    </Grid>
                )}
                <Grid item xs={nullable ? 9 : 12} style={{ paddingLeft: nullable ? '0px' : '0px' }}>
                    <FormControl id={'reactDateTime'} className={classes.formControl} style={{ minWidth: '100px' }}>
                        <Datetime
                            autoComplete={autoComplete ?? 'off'}
                            timeFormat={timeFormat}
                            locale="pl"
                            {...this.props}
                            dateFormat={true}
                            defaultValue={nowStart}
                            onChange={(moment: Moment | string): void => this.dateTimeCallback(moment, fieldName + '[after]')}
                            inputProps={{
                                id: fieldName + '[after]',
                                disabled: !!(valueAfter && valueAfter === 'null'),
                                placeholder: dateF,
                                onKeyPress: this.actionChange,
                                autoComplete: autoComplete ?? 'off',
                                value: valueAfter,
                                style: { ...styleAppendix },
                            }}
                        />
                    </FormControl>
                    {breakLine && <br />}
                    <FormControl id={'reactDateTime'} className={classes.formControl} style={{ minWidth: '100px' }}>
                        <Datetime
                            autoComplete={autoComplete ?? 'off'}
                            timeFormat={timeFormat}
                            locale="pl"
                            {...this.props}
                            defaultValue={defaultValue || nowEnd}
                            dateFormat={true}
                            onChange={(moment: Moment | string): void => this.dateTimeCallback(moment, fieldName + '[before]')}
                            inputProps={{
                                id: fieldName + '[before]',
                                disabled: !!(valueBefore && valueBefore === 'null'),
                                placeholder: dateF,
                                onKeyPress: this.actionChange,
                                value: valueBefore,
                                autoComplete: autoComplete ?? 'off',
                                style: { ...styleAppendix },
                            }}
                        />
                    </FormControl>
                </Grid>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.clearAll) {
        return {
            clearField: true,
        };
    }
    return {};
};
export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(EsDateTimeFromTo);
